/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 30.06.2016
 */

'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { AppContext, debounce, Title } from 'plugin/liferay-widgets-react-web';
import { BusinessObjectSelect, ClassNames as BaseClassNames } from 'plugin/base-portlet';

import FliwasOrganizationActions from '../actions/FliwasOrganizationActions';
import { getFliwasOrganizationStore } from '../stores/StoreFactory';

import FliwasOrganizationMapLinkListItem from '../map/FliwasOrganizationMapLinkListItem';

class FliwasOrganizationConfigForm extends React.Component {

    constructor(props){
        super(props);
        this.searchOrganizations = debounce(this.searchOrganizations.bind(this), 300);
    }

    withCtx(s){
        return this.props.formId + '.' + s;
    }

    moreFliwasOrganizations(listName, query){
        FliwasOrganizationActions.moreItems(listName, query);
    }

    searchOrganizations(list, query){
        FliwasOrganizationActions.search(list, {
            ...query
        });
    }

    change(o){
        this.props.onChange({ ...this.props.formData, ...o });
    }

    onChange(formData){
        this.change(formData);
    }

    render(){
        return (
            <fieldset>
                <Title title="Bitte Mandanten auswählen"/>
                <BusinessObjectSelect
                    {...this.props}
                    formData={this.props.formData}
                    onChange={this.onChange.bind(this)}
                    CustomMapLinkListItem={FliwasOrganizationMapLinkListItem}
                    className={BaseClassNames.Group}
                    propName={'groupId'}
                    onMore={this.moreFliwasOrganizations.bind(this)}
                    store={getFliwasOrganizationStore(AppContext)}
                    onSearch={this.searchOrganizations.bind(this)}
                    showMap={false}
                />
            </fieldset>
        );
    }
}

FliwasOrganizationConfigForm.propTypes = {
    onChange: PropTypes.func,
    formData: PropTypes.object,
    formId: PropTypes.string
};

export default FliwasOrganizationConfigForm;



// WEBPACK FOOTER //
// ./js/widgets/FliwasOrganizationConfigForm.jsx